import _slicedToArray from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\slicedToArray.js";

/* eslint-disable react-hooks/exhaustive-deps */
import querySelectorAll from 'dom-helpers/querySelectorAll';
import React, { useCallback, useContext, useLayoutEffect, useMemo, useState, useRef } from 'react';
export var FocusListContext = /*#__PURE__*/React.createContext(null);
var defaultOpts = {
  behavior: 'stop'
};
export function useListOption(dataItem) {
  var ctx = useContext(FocusListContext);
  var prevElement = useRef(null); // this is a bit convoluted because we want to use a ref object, a callback ref
  // causes an extra render which is fine except that it means the list hook for
  // anchor items fires before elements are processed

  var ref = useRef(null);
  useLayoutEffect(function () {
    return function () {
      ctx == null ? void 0 : ctx.map.delete(ref.current);
    };
  }, []);
  useLayoutEffect(function () {
    if (prevElement.current !== ref.current) {
      ctx == null ? void 0 : ctx.map.delete(prevElement.current);
    }

    prevElement.current = ref.current;

    if (ref.current && (ctx == null ? void 0 : ctx.map.get(ref.current)) !== dataItem) {
      ctx == null ? void 0 : ctx.map.set(ref.current, dataItem);
    }
  });
  var focused = dataItem === (ctx == null ? void 0 : ctx.focusedItem);
  return [ref, focused, focused ? ctx == null ? void 0 : ctx.activeId : undefined];
}
export var useFocusList = function useFocusList(_ref) {
  var listRef = _ref.scope,
      anchorItem = _ref.anchorItem,
      _ref$focusFirstItem = _ref.focusFirstItem,
      _focusFirstItem = _ref$focusFirstItem === void 0 ? false : _ref$focusFirstItem,
      _ref$scopeSelector = _ref.scopeSelector,
      _scopeSelector = _ref$scopeSelector === void 0 ? '' : _ref$scopeSelector,
      activeId = _ref.activeId;

  var map = useMemo(function () {
    return new WeakMap();
  }, []);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      focusedItem = _useState2[0],
      setFocusedItem = _useState2[1];

  var itemSelector = "".concat(_scopeSelector, " [data-rw-focusable]").trim();

  var get = function get() {
    var items = querySelectorAll(listRef.current, itemSelector);
    return [items, items.find(function (e) {
      return e.dataset.rwFocused === '';
    })];
  };

  var list = useMemo(function () {
    return {
      size: function size() {
        var _get = get(),
            _get2 = _slicedToArray(_get, 1),
            items = _get2[0];

        return items.length;
      },
      get: get,
      toDataItem: function toDataItem(el) {
        return map.get(el);
      },
      first: function first() {
        var _get3 = get(),
            _get4 = _slicedToArray(_get3, 1),
            _get4$ = _slicedToArray(_get4[0], 1),
            first = _get4$[0];

        return first;
      },
      focus: function focus(el) {
        if (!el || map.has(el)) setFocusedItem(el ? map.get(el) : undefined);
      },
      last: function last() {
        var _get5 = get(),
            _get6 = _slicedToArray(_get5, 1),
            items = _get6[0];

        return items[items.length - 1];
      },
      next: function next() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpts,
            behavior = _ref2.behavior;

        var _get7 = get(),
            _get8 = _slicedToArray(_get7, 2),
            items = _get8[0],
            focusedItem = _get8[1];

        var nextIdx = items.indexOf(focusedItem) + 1;

        if (nextIdx >= items.length) {
          if (behavior === 'loop') return items[0];
          if (behavior === 'clear') return undefined;
          return focusedItem;
        }

        return items[nextIdx];
      },
      prev: function prev() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOpts,
            behavior = _ref3.behavior;

        var _get9 = get(),
            _get10 = _slicedToArray(_get9, 2),
            items = _get10[0],
            focusedItem = _get10[1];

        var nextIdx = Math.max(0, items.indexOf(focusedItem)) - 1;

        if (nextIdx < 0) {
          if (behavior === 'loop') return items[items.length - 1];
          if (behavior === 'clear') return undefined;
          return focusedItem;
        }

        return items[nextIdx];
      }
    };
  }, []);
  useLayoutEffect(function () {
    if (!anchorItem) {
      list.focus(null);
      return;
    }

    var element = get()[0].find(function (el) {
      return list.toDataItem(el) === anchorItem;
    });
    list.focus(element);
  }, [anchorItem]);
  useLayoutEffect(function () {
    if (!listRef.current) return;

    var _get11 = get(),
        _get12 = _slicedToArray(_get11, 2),
        focusedElement = _get12[1];

    var hasItem = focusedElement != null;

    if (!hasItem && _focusFirstItem || hasItem && !listRef.current.contains(focusedElement)) {
      if (_focusFirstItem) list.focus(list.first());else list.focus(null);
    }
  });
  var context = useMemo(function () {
    return {
      map: map,
      focusedItem: focusedItem,
      activeId: activeId
    };
  }, [focusedItem, activeId]);
  list.context = context;
  list.getFocused = useCallback(function () {
    return focusedItem;
  }, [focusedItem]);

  list.hasFocused = function () {
    return focusedItem !== undefined;
  };

  return list;
};